import React from "react";
import API from "../../base/API";
import { getUser } from "../../auth/Auth";
import ReactJson from 'react-json-view';
import Chart from "./Chart";
import PDFButton from "./PDFButton";
import Equalizer from "react-equalizer";
import {translate} from "../../base/Translation";

export default class TestResult extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            get_weave_group_results: "/test/fetch/weave_group/results/:weave_group?branch=:branch",
        });

        this.state = {
            branch_results: [],
            chartData: [],
            chartDataSections: [],
            chartDataProtocols: [],
            chartBarsProtocols: [],
        }
    }

    componentDidUpdate(nextProps) {
        if (nextProps.test !== this.props.test) {
            this.componentDidMount();
        }
    }

    componentDidMount() {
        this.api.request({
            cache: false,
            route: "get_weave_group_results",
            params: { weave_group: this.props.test.weave_data.weave_group.id, branch: this.props.test.branch },
            success: function (response) {
                this.processResults(response);
            }.bind(this)
        });
    }

    max100(num) {
        return num > 100 ? 100 : Math.round(num);
    }

    processResults(data) {
        this.setState({ branch_results: data });
        this.processStats(data);
        this.processResultsSections(data);
        this.processResultsProtocol(data);
    }

    processStats(data) {
        let chartData = [];

        if (this.props.test.weave_data.req_perc > 0) {
            chartData = [
                { name: translate('Celkový výsledok') },
                { name: translate('Komunikácia') },
                { name: translate('Technika') },
            ]
        } else {
            chartData = [
                { name: translate('Komunikácia') },
                { name: translate('Technika') },
            ]
        }

        for (let i = 0; i < data.length; i++) {
            let test = data[i];
            if (this.props.test.weave_data.req_perc > 0) {
                chartData[0][test.name] = this.max100(test.result.percentage);
                if (typeof test.result.form !== "undefined") {
                    chartData[1][test.name] = this.max100(test.result.form.percentage);
                }
                if (typeof test.result.protocol !== "undefined") {
                    chartData[2][test.name] = this.max100(test.result.protocol.percentage);
                }
            } else {
                if (typeof test.result.form !== "undefined") {
                    chartData[0][test.name] = this.max100(test.result.form.percentage);
                }
                if (typeof test.result.protocol !== "undefined") {
                    chartData[1][test.name] = this.max100(test.result.protocol.percentage);
                }
            }
        }

        this.setState({ chartData });
    }

    processResultsSections(data) {
        let chartDataSections = [];
        let usedSections = [];

        for (let i = 0; i < data.length; i++) {
            let test = data[i];
            if (typeof test.result.form !== "undefined") {
                for (let key in test.result.form.sections_stats) {
                    let section = test.result.form.sections_stats[key];
                    if (usedSections.indexOf(section.name) > -1) {
                        continue;
                    }
                    let res = { name: section.name };
                    chartDataSections.push(res);
                    usedSections.push(section.name);
                }
            }
        }

        chartDataSections.forEach((result) => {
            for (let i = 0; i < data.length; i++) {
                let test = data[i];
                if (typeof test.result.form !== "undefined") {
                    for (let key in test.result.form.sections_stats) {
                        let section = test.result.form.sections_stats[key];

                        if (section.name === result.name) {
                            result[test.name] = this.max100(section.percentage);
                        }

                    }
                }
            }
        });

        this.setState({ chartDataSections });
    }

    processResultsProtocol(data) {
        let chartDataProtocols = [];
        let usedSections = [];
        let error_db = translate("Identifikácia chýb");

        for (let i = 0; i < data.length; i++) {
            let test = data[i];
            if (typeof test.result.protocol !== "undefined") {

                /* Error DB */
                if (usedSections.indexOf(error_db) < 0) {
                    let res = { name: error_db };
                    chartDataProtocols.push(res);
                    usedSections.push(error_db);
                }
                /* End error db */

                for (let key in test.result.protocol.form.sections_stats) {
                    let section = test.result.protocol.form.sections_stats[key];
                    if (usedSections.indexOf(section.name) > -1) {
                        continue;
                    }
                    let res = { name: section.name };
                    chartDataProtocols.push(res);
                    usedSections.push(section.name);
                }
            }
        }

        chartDataProtocols.forEach((result) => {
            for (let i = 0; i < data.length; i++) {
                let test = data[i];
                if (typeof test.result.protocol !== "undefined") {

                    /* Error DB */
                    if (error_db === result.name) {
                        result[test.name] = this.max100(test.result.protocol.error_db.percentage);
                    }
                    /* End error db */

                    for (let key in test.result.protocol.form.sections_stats) {
                        let section = test.result.protocol.form.sections_stats[key];

                        if (section.name === result.name) {
                            result[test.name] = this.max100(section.percentage);
                        }

                    }
                }
            }
        });

        // console.log(chartDataProtocols);

        chartDataProtocols.forEach((part, partIndex) => {
            let hasHigherThanZero = false;

            // console.log("Checking part:", part.name);

            for (let key in part) {

                if (key === "name") {
                    continue;
                }

                // console.log(key, part[key], parseFloat(part[key]) > 0)

                if (parseFloat(part[key]) > 0) {
                    hasHigherThanZero = true;
                    break;
                }

            }

            if (!hasHigherThanZero) {
               delete chartDataProtocols[partIndex];
            }

           // console.log(chartDataProtocols);

        });

        this.setState({ chartDataProtocols });
    }

    renderOtherCharts() {
        return (
            <div className="row">
                {this.renderBranchFormChart()}
                {this.renderBranchProtocolChart()}
            </div>
        )
    }

    renderFormStats() {

        const form = this.props.test.result.form;
        let sections = Object.keys(form.sections_stats).map(function (key) {
            return form.sections_stats[key];
        });

        return (
            <div className="col-sm-12 col-md-12">
                <table style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}><h4>{translate("Komunikácia")}</h4></th>
                            <th style={{ width: "15%", textAlign: "right" }}>
                                <h4 style={{ color: form.percentage >= form.min_perc ? "blue" : "red" }}>{form.percentage} % <small>{this.props.test.result.min_success > 0 ? "" : "(min. " + form.min_perc + " %)"}</small></h4>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sections.map((section, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}. {section.name}</td>
                                    <td style={{ textAlign: "right" }}>{section.percentage > 0 ? this.max100(Math.round(section.percentage)) + " %" : ""}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        );

    }

    renderProtocolStats() {
        const protocol = this.props.test.result.protocol;
        const form = this.props.test.result.protocol.form;
        const error_db = this.props.test.result.protocol.error_db;

        let sections = Object.keys(form.sections_stats).map(function (key) {
            return form.sections_stats[key];
        });

        return (
            <div className="col-sm-12 col-md-12">
                <table style={{ marginTop: "20px", width: "100%" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}><h4>{translate("Technika")}</h4></th>
                            <th style={{ width: "15%", textAlign: "right" }}>
                                <h4 style={{ color: protocol.percentage >= form.min_perc ? "blue" : "red" }}>{protocol.percentage} % <small>{this.props.test.result.min_success > 0 ? "" : "(min. " + form.min_perc + " %)"}</small></h4>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1. {translate("Identifikácia chýb")}</td>
                            <td style={{ textAlign: "right" }}>{Math.round(error_db.base_percentage)} %</td>
                        </tr>
                        {sections.map((section, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 2}. {section.name}</td>
                                    <td style={{ textAlign: "right" }}>{section.percentage > 0 ? this.max100(Math.round(section.percentage)) + " %" : ""}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        );

    }

    renderStatsPanel() {

        return (
            <div className="panel panel-default" style={{ height: "100%" }}>
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="pull-left" style={{ color: this.props.test.result.success ? "blue" : "red", fontWeight: "bold", margin: "0", marginTop: "0.5rem" }}>
                                {this.props.test.result.success ? translate("Vyhovel") +" " : translate("Nevyhovel") + " "}
                                {this.props.test.result.min_success > 0 ? <span style={{ paddingLeft: "5px" }}>{Math.round(this.props.test.result.percentage)} %</span> : ""}
                                {this.props.test.result.min_success > 0 ? <small style={{ color: "black", fontWeight: "bold" }}> (min. {this.props.test.result.min_success} %)</small> : ""}
                            </h4>
                            <PDFButton type="summary" test={this.props.test} />
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    <div className="row">
                        {this.renderFormStats()}
                        {this.renderProtocolStats()}
                    </div>
                </div>
            </div>
        )
    }

    renderTestResultsBreakDown() {
        if (getUser().role < 5) {
            return false;
        }

        return (
            <div className="panel panel-default">
                <div className="panel-heading">Breakdown</div>
                <div className="panel-body">
                    {this.renderTestResultsBreakDownTable(this.props.test.result.form)}
                    {this.renderTestResultsBreakDownTable(this.props.test.result.protocol)}
                    {this.renderTestResultsJson()}
                </div>
            </div>
        )
    }

    renderTestResultsJson() {
        return (
            <div>
                <h4>JSON Data</h4>
                <ReactJson collapsed={true} src={this.props.test.result} />
            </div>
        )
    }

    renderTestResultsBreakDownTable(data) {
        if (typeof data === "undefined") {
            return false;
        }

        let item = data;

        if (typeof item.sections_stats === "undefined") {
            item = data.form;
        }

        let sections = Object.keys(item.sections_stats).map(function (key) {
            return item.sections_stats[key];
        });

        if (typeof data.error_db !== "undefined") {
            sections.unshift(
                {
                    "name": "Identifikácia chýb",
                    "weight": data.error_db.weight,
                    "achieved_points": data.error_db.achieved_points,
                    "max_points": data.error_db.max_points,
                    "percentage": Math.round(data.error_db.base_percentage)
                }
            )
        }

        return (
            <div>

                <table className="table table-bordered" key={item.name}>
                    <thead>
                        <tr>
                            <th>{item.name}</th>
                            <th style={{ width: "15%" }}>Weight</th>
                            <th style={{ width: "15%" }}>Achieved Points</th>
                            <th style={{ width: "15%" }}>Max Points</th>
                            <th style={{ width: "15%" }}>Weighted perc</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sections.map(function (section, index) {
                            /*let groups = Object.keys(section.groups).map(function (key) {
                                return section.groups[key];
                            });*/
                            return (
                                <tr key={index}>
                                    <td>{section.name}</td>
                                    <td>{section.weight} %</td>
                                    <td>{section.achieved_points}</td>
                                    <td>{section.max_points}</td>
                                    <td>{Math.round(section.percentage)} %</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

            </div>
        )

    }

    renderChildRows(parent, rows, level = 0) {

        const childRows = rows.filter(function (row) {
            return row.parent === this;
        }.bind(parent));

        for (let i = 0; i < childRows.length; i++) {
            const row = childRows[i];

            const style = { paddingLeft: ((level + 1) * 10 + "px") };
            const className = "row " + row.id + " parent-" + row.parent;
            const key = i + level + "_" + row.id;

            this.processedRows.push(<div key={key} style={style} className={className}>{row.content()}</div>);
            this.renderChildRows(row.id, rows, level + 1);
        };

        return this.processedRows;
    }

    renderBranchStatsChart() {
        return (
            <div className="panel panel-default" style={{ height: "100%" }}>
                <div className="panel-heading">
                    {translate("Štatistika")}
                </div>
                <div className="panel-body">
                    <Chart data={this.state.chartData} bars={this.state.branch_results} />
                </div>
            </div>
        )
    }

    renderBranchFormChart() {
        return (
            <div className="col-sm-12 col-md-6">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        {translate("Komunikácia")}
                    </div>
                    <div className="panel-body">
                        <Chart data={this.state.chartDataSections} bars={this.state.branch_results} />
                    </div>
                </div>
            </div>
        )
    }

    renderBranchProtocolChart() {
        return (
            <div className="col-sm-12 col-md-6">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        {translate("Technika")}
                    </div>
                    <div className="panel-body">
                        <Chart data={this.state.chartDataProtocols} bars={this.state.branch_results} />
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (!this.props.test.result) {
            return;
        }

        return (
            <div>
                <div className="row">
                    <Equalizer>
                        <div className="col-xs-12 col-md-6" style={{ paddingBottom: "30px" }}>
                            {this.renderStatsPanel()}
                        </div>
                        <div className="col-xs-12 col-md-6" style={{ paddingBottom: "30px" }}>
                            {this.renderBranchStatsChart()}
                        </div>
                    </Equalizer>
                </div>
                {this.renderOtherCharts()}
                {/*this.renderTestResultsBreakDown()*/}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/parts/TestResult.jsx